import { render, staticRenderFns } from "./MenuTranslate.vue?vue&type=template&id=dfde21b0"
import script from "./MenuTranslate.vue?vue&type=script&lang=js"
export * from "./MenuTranslate.vue?vue&type=script&lang=js"
import style0 from "./MenuTranslate.vue?vue&type=style&index=0&id=dfde21b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports